// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"aboutus_aboutContainer__1zFsT","item":"aboutus_item__L3Wzl","text":"aboutus_text__2c15s","arrow":"aboutus_arrow__CXpxW"};